export class BaseProvider {
	list: any[];
	item: any;
	url: any;
	token: any;
	baseUrl: any;
	
	constructor() {
		this.list = [];
	}

	pushItem(item){
		this.list.push(item);
	}

	pushItems(items){
		for (var i = 0; i < items.length; i++) {			
			this.list.push(items[i]);
		}		
	}

	updateItem(item){
		let filteredlist: any[] = this.list.filter(d => d.Id === item.Id);

		Object.assign(filteredlist[0], item);
	}

	removeItem(id){
		for (var i = this.list.length - 1; i >= 0; i--) {
			if(this.list[i].Id == id){
				this.list.splice(i, 1);
				break;
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/providers/base-provider.ts